import React from "react";
import { Card, Col, Row } from "antd";
import "./styles.css";

const TopSummaryItem = ({
  heading,
  label1,
  value1,
  label2,
  value2,
  cardType,
  label,
  value,
}) => (
  <Col xxl={6} xl={6} lg={6} md={12} sm={12} xs={8}>
    <Card
      bordered={false}
      title={cardType && heading}
      className="custom-card-style"
      headStyle={
        cardType && {
          color: "#0f6788",
          textTransform: "uppercase",
          fontWeight: "bolder",
          padding: 0,
          minHeight: "auto",
        }
      }
      bodyStyle={{ padding: "12px 16px" }}
      style={{
        height: "100%",
        borderRadius: "8px",
        backgroundColor: "#fff",
        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
      }}
    >
      <div className="summary-content">
        {label1 && value1 && (
          <p className="summary-item">
            <span className="summary-label">{label1}:</span>
            <span className="summary-value">{value1}</span>
          </p>
        )}
        {label2 && value2 && (
          <p className="summary-item">
            <span className="summary-label">{label2}:</span>
            <span className="summary-value">{value2}</span>
          </p>
        )}
        {label && value && (
          <p className="summary-item">
            <span className="summary-label">{label}:</span>
            <span className="summary-value">{value}</span>
          </p>
        )}
      </div>
    </Card>
  </Col>
);

const TopSummary = ({ summaries, cardType = false }) => {
  return (
    <Row
      gutter={[16, 16]}
      style={{
        width: "100%",
        marginBottom: "10px",
      }}
      className="top-summary-container"
    >
      {summaries.map((summary, index) => {
        const { heading, label1, value1, label2, value2, label, value } =
          summary;
        return (
          <TopSummaryItem
            key={index}
            heading={heading}
            label1={label1}
            value1={value1}
            label2={label2}
            value2={value2}
            label={label}
            value={value}
            cardType={cardType}
          />
        );
      })}
    </Row>
  );
};

export default TopSummary;
